import clsx from 'clsx';
import { useState } from 'react';
import { AcceptIcon } from '@/assets/react-icons/AcceptIcon';
// import { EditIcon } from '@/assets/react-icons/EditIcon';
import { Button } from '@/components/Button';
import { Input } from '@/components/Input';
import { Text } from '@/components/Text';
import styles from './EditOwnerFullName.module.scss';
type Props = {
  advertisementAuthor: {
    firstName: string;
    lastName: string;
    patronymic: string;
  };
  className?: string;
};
export const EditOwnerFullName = ({
  advertisementAuthor,
  className
}: Props) => {
  const [isEditFullNameMode, setEditFullNameMode] = useState(false);
  const {
    firstName,
    lastName,
    patronymic
  } = advertisementAuthor;
  const handleSave = () => {
    setEditFullNameMode(false);
  };
  const editOwnerFullName = <div className={styles['owner-inputs-wrapper']}>
      <Input defaultValue={lastName} placeholder='Прізвище:' />
      <Input defaultValue={firstName} placeholder='Ім’я:' />
      <Input defaultValue={patronymic} placeholder='По-батькові:' />
      <Button fullWIdth icon={<AcceptIcon />} onClick={handleSave} small>
        Зберегти
      </Button>
    </div>;
  return <div className={clsx(styles.wrapper, className)} data-sentry-component="EditOwnerFullName" data-sentry-source-file="EditOwnerFullName.tsx">
      <div className={styles.dataOwnerTop}>
        <Text color='text-gray' type='p2' data-sentry-element="Text" data-sentry-source-file="EditOwnerFullName.tsx">
          Дані власника:
        </Text>
        {!isEditFullNameMode && <div className={styles.fullName}>
            <Text type='p2'>
              {lastName} {firstName} {patronymic}
            </Text>
            {/* <button className={styles.editFullNameBtn} onClick={() => setEditFullNameMode(true)}>
              <EditIcon />
             </button> */}
          </div>}
      </div>
      {isEditFullNameMode && editOwnerFullName}
      <Text color='basic-green' type='p4' data-sentry-element="Text" data-sentry-source-file="EditOwnerFullName.tsx">
        *Перевірте, будь ласка, правильність вказаної інформації
      </Text>
    </div>;
};